import {
  trackEvent,
  setUserId,
  setUserProfile,
  trackFormInput,
  aliasUser,
  resetPosthog,
  getFeatureFlag,
  isFeatureEnabled,
  getAllFeatureFlags,
  onFeatureFlags,
} from "@/services/posthog";

const usePosthog = () => {
  return {
    trackEvent,
    setUserId,
    setUserProfile,
    trackFormInput,
    aliasUser,
    resetPosthog,
    getFeatureFlag,
    isFeatureEnabled,
    getAllFeatureFlags,
    onFeatureFlags,
  };
};

export { usePosthog };
